<template>
  <pack>
    <div class="version">
      <el-form :model="ver" label-width="150px" label-position="left">
        <el-form-item label="IOS最低支持版本:">
          <el-input v-model="ver.ios_version_code"></el-input>
        </el-form-item>
        <el-form-item label="安卓最低支持版本:">
          <el-input v-model="ver.android_version_code"></el-input>
        </el-form-item>
        <el-form-item label>
          <zt-button type="primary" @click="save">保存</zt-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="app-template">
      <transition name="fade-transform" mode="out-in">
        <div class="tempale-List" v-if="!edit">
          <el-form label-position="left" label-width="130px">
            <el-form-item label="当前使用模板">
              <div class="card">
                <div
                  class="card-item"
                  :style="`background-image:url('${activeTemplate.thum_image}');`"
                ></div>
                <p class="card-title">{{activeTemplate.name}}</p>
              </div>
            </el-form-item>
            <el-form-item label="模板库">
              <div class="card" @click="addTemplate">
                <div class="card-item add">
                  <!-- <div class="card-cover"></div> -->
                  <i class="el-icon-plus"></i>
                  <!-- <svg-icon icon="gou_bule" class="icon-active"></svg-icon> -->
                </div>
                <p class="card-title">新增模板</p>
              </div>
              <div
                class="card"
                @mouseenter="cardMouseenter(idx)"
                @mouseleave="cardMouseLeave()"
                v-for="(item,idx) in templateList"
                :key="item.id"
              >
                <div
                  class="card-item"
                  :style="`background-image:url('${item.thum_image}');`"
                  :class="`${item.active==1?'active':''}`"
                >
                  <div
                    class="card-cover"
                    v-if="idx==cardHover"
                    :class="`${item.active==1?'cover-active':''}`"
                  ></div>
                  <svg-icon icon="gou_bule" class="icon-active" v-if="item.active == 1"></svg-icon>
                  <div class="card-btn-box" v-if="idx==cardHover">
                    <zt-button
                      class="cli-default"
                      :disabled="item.active==1"
                      @click="chooseTemplate(item)"
                    >使用</zt-button>
                    <zt-button
                      class="cli-default"
                      :disabled="item.is_default==1"
                      @click="handlEditTemplate(item)"
                    >编辑</zt-button>
                    <zt-button
                      class="cli-warn"
                      :disabled="item.is_default==1||item.active==1"
                      @click="delTemplate(item)"
                    >删除</zt-button>
                  </div>
                </div>
                <p class="card-title">{{item.name}}</p>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <template-edit v-else @back="closeEdit" :editTemplateData="editTemplate"></template-edit>
      </transition>
    </div>
  </pack>
</template>

<script>
import templateEdit from '@v/extension/appManage/components/components/templateEdit';
import {
  admin_plugin_app_theme_list,
  admin_plugin_app_style_set,
  admin_plugin_app_info2,
  admin_plugin_app_theme_delete,
  admin_plugin_app_version
} from '@/api/extension';
export default {
  components: { templateEdit },
  name: 'adminAppTest',
  data: () => ({
    ver: {
      id: 11,
      android_version_code: '',
      ios_version_code: '',
    },
    markType: 'android',
    editTemplate: '',
    defaultTemplate: {
      id: 0,
      name: '经典',
      thum_image: 'http://img.zhutui.cn/20200303/d1ba9840476cebb.png',
    },
    activeTemplate: '',
    activeId: '',
    edit: false,
    cardHover: -1,
    templateList: [],
  }),
  methods: {
    // 保存版本
    save() {
      admin_plugin_app_version(this.ver).then(({ data }) => {
        if (data.error_code == 0) {
          this.$message.success('保存版本成功');
          this.getActiveTemplate();
        } else {
          this.$message.error(data.error_message);
        }
      });
    },
    async delTemplate(item) {
      this.$confirm('确定删除此模板？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        // eslint-disable-next-line
        .then(async () => {
          const { data } = await admin_plugin_app_theme_delete({
            id: item.id,
          });
          if (data.error_code == 0) {
            this.$message.success('删除模板成功');
            this.getActiveTemplate();
          } else {
            this.$message.error(data.error_message);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 新增
    addTemplate() {
      if (this.templateList.length == 7)
        return this.$message.error('已达到最多添加数量');
      this.editTemplate = {};
      this.edit = true;
    },
    // 编辑
    handlEditTemplate(item) {
      this.cardMouseLeave();
      this.editTemplate = item;
      this.edit = true;
    },
    //设置使用模板
    async chooseTemplate(item) {
      const { data } = await admin_plugin_app_style_set({
        app_theme: item.id,
      });
      if (data.error_code == 0) {
        this.$message.success('应用模板成功');
        this.activeTemplate = item;
        this.getActiveTemplate();
      } else {
        this.$message.error(data.error_message);
      }
    },
    //获取当前使用模板
    async getActiveTemplate() {
      const { data } = await admin_plugin_app_info2({ id: 11 });
      if (data.error_code == 0) {
        this.ver = {
          id: 11,
          android_version_code: data.info.android_version_code,
          ios_version_code: data.info.ios_version_code,
        };
        this.activeId = data.info.app_theme;
        //使用默认模板
        if (this.activeId == 0) {
          this.activeTemplate = this.defaultTemplate;
        }
        this.getTemplateList();
      }
    },
    //获取模板列表
    async getTemplateList() {
      const { data } = await admin_plugin_app_theme_list();
      if (data.error_code == 0) {
        data.list.map((item) => {
          if (item.id == this.activeId) {
            this.activeTemplate = item;
            item.active = 1;
          } else {
            item.active = 0;
          }
        });
        this.templateList = data.list;
      }
    },
    closeEdit() {
      this.getActiveTemplate();
      this.edit = false;
    },
    cardMouseenter(idx) {
      this.cardHover = idx;
    },
    cardMouseLeave() {
      this.cardHover = -1;
    },
  },
  mounted() {
    this.getActiveTemplate();
  },
};
</script>

<style lang="scss" scoped>
.version {
  margin-bottom: 30px;
  border-style: solid;
  border-color: #ebeef5;
  border-width: 0px 0px 1px 0px;
  padding-bottom: 30px;
  /deep/ .el-input {
    width: 200px;
  }
  /deep/ .zt-button {
    width: 100px;
  }
}
.app-template {
  margin-top: 8px;
  .card {
    margin-right: 48px;
    margin-bottom: 24px;
    display: inline-block;
    .card-item {
      box-sizing: content-box;
      cursor: pointer;
      position: relative;
      width: 118px;
      height: 204px;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 6px;
      border: 1px solid rgba(235, 238, 245, 1);
      img {
        width: 118px;
        height: 204px;
        position: absolute;
        top: 0px;
        left: 0px;
        border-radius: 6px;
      }
      .card-cover {
        box-sizing: content-box;
        border-radius: 6px;
        background: rgba(0, 0, 0, 0.24);
        position: absolute;
        top: 0px;
        left: -2px;
        width: 120px;
        height: 204px;
      }
      .cover-active {
        width: 118px;
        height: 204px;
        top: -2px;
        left: -2px;
        border: 2px solid rgba(64, 158, 255, 1);
      }
      .card-btn-box {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        z-index: 2;
        margin: auto;
        /deep/ .zt-button {
          transition: all 0.2s;
          padding: 0px;
          box-sizing: border-box;
          background: #fff;
          width: 56px;
          height: 36px;
          border-radius: 2px;
          border: 1px solid rgba(141, 146, 153, 1);
        }
        /deep/ .cli-default {
          &:hover {
            background: $theme;
            color: #fff;
            border: 1px solid $theme;
          }
        }
        /deep/ .cli-warn {
          &:hover {
            background: #fe4242;
            color: #fff;
            border: 1px solid #fe4242;
          }
        }
        /deep/ .is-disabled {
          &:hover {
            background: #fff;
            color: #c0c4cc;
            border: 1px solid rgba(141, 146, 153, 1);
          }
        }
        // /deep/ .el-button:focus, .el-button:hover{
        //   color: #46494D
        // }
      }
      i {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: #c1c9d2;
        font-size: 28px;
      }
      .svg-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 24px;
      }
      .icon-active {
        color: $theme;
      }
    }
    .add {
      border-style: dashed;
    }
    .active {
      border: 2px solid rgba(64, 158, 255, 1);
    }
    .card-title {
      margin-top: 16px;
      text-align: center;
      font-size: 14px;
      color: rgba(35, 37, 38, 1);
      line-height: 20px;
    }
  }
}
</style>